import { IntlShape } from "react-intl";
import { SelectItemInterface } from "../interface/SelectItemInterface";
import { MESSAGE_TYPE } from "./constant";
import { displaySnackBar } from "./snackBarUtils";

const compare = (a: SelectItemInterface, b: SelectItemInterface) => {
  if (a.label < b.label) {
    return -1;
  }
  if (a.label > b.label) {
    return 1;
  }
  return 0;
};
export const sortArray = (array: any, type?: string): SelectItemInterface[] => {
  return array.sort(compare);
};

export const sortByKey = (array: any, key: string, type: string) => {
  return array.sort(function (a: any, b: any) {
    const x = a[key],
      y = b[key];
    // is string
    if (type === "ASC")
      return compare(x ? x.toLowerCase() : "", y ? y.toLowerCase() : "");
    else return compare(y ? y.toLowerCase() : "", x ? x.toLowerCase() : "");
  });
};

export const isNotValidCardNumber = (cardNumber: string) => {
  const _cn = cardNumber.replace(/ /g, "");
  return !cardNumber || isNaN(+_cn);
};

export const removeSpace = (word: string): string => {
  return word.replace(/ /g, "");
};

export const removeSpecialChars = (word: string): string => {
  const string = removeSpace(word);
  return string.replace(/[^a-zA-Z0-9.]/g, "");
};

export const setPriceLocale = (price: any): string => {
  const supportedLanguages = ["en-US", "fr-FR"];

  let locale: string =
    (navigator.languages && navigator.languages[0]) ||
    navigator.language ||
    "fr-FR";

  locale = locale === "fr" ? "fr-FR" : locale;

  if (!supportedLanguages.find((l) => l === locale)) {
    locale = "fr-FR";
  }

  if (localStorage.getItem("language")) {
    locale = localStorage.getItem("language") || "";
  }
  const currency = locale === "fr-FR" ? "EUR" : "EUR"; // => USD if english
  return new Intl.NumberFormat(locale, { style: "currency", currency }).format(
    price,
  );
};

export const formatAmount = (amount: string): string => {
  amount = amount.replace(/\s+/g, "");
  return amount.replace(/[,.]/g, ".");
};

export const formatPrice = (amount: number, nFraction?: number): string => {
  const price = amount.toLocaleString("fr-FR", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: nFraction ? nFraction : 0,
  });
  return price;
};

export const displayError = (
  client: any,
  intl: IntlShape,
  messageId: string,
) => {
  displaySnackBar(client, {
    type: MESSAGE_TYPE.ERROR,
    message: intl.formatMessage({ id: messageId }),
    isOpen: true,
  });
};

export const getPercent = (total: number, currentValue: number) => {
  const ret = (currentValue * 100) / total;
  return ret.toFixed(2);
};

export const checkNAF = (naf: string): boolean => {
  return /^[0-9]{4}[a-z,A-Z]{1}$/.test(naf);
};
